<template>
  <div :id="mapName"
       class="google-map" />
</template>

<script>
export default {
  props: {
    location: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    mapName: 'google-map'
  }),
  mounted: function() {
    const element = document.getElementById(this.mapName)
    var myLatlng = new window.google.maps.LatLng(
      this.location.latitude,
      this.location.longitude
    )
    const options = {
      zoom: 17,
      center: myLatlng
    }
    const map = new window.google.maps.Map(element, options)
    var marker = new window.google.maps.Marker({
      position: myLatlng,
      map: map,
      title: 'location'
    })
  }
}
</script>

<style lang="scss">
@import './w-google-map.sass';
</style>
